
    const countdownEndTime = document.getElementById("promo-countdown__countdown-circles-container").getAttribute('data-promo-countdown');
    const countDownDate = new Date(countdownEndTime).getTime();

    const startDay = document.getElementById("promo-countdown__countdown-circle--days").getAttribute('data-countdown-days');
    const countDownStartDate = new Date(startDay).getTime();
    const dayDistance = Math.floor((countDownDate - countDownStartDate) / (1000 * 60 * 60 * 24));

    const PromoCountdownCirclesUpdate = setInterval(function() {
    const circles = document.querySelectorAll(".promo-countdown__circle-count");
    const circlesSecondary = document.querySelectorAll(".promo-countdown__circle-count-secondary");

    if (window.innerWidth <= 1050) {
    circles.forEach((circle)=> {circle.setAttribute("r", "70"); circle.setAttribute("cx", "75"); circle.setAttribute("cy", "75");});
    circlesSecondary.forEach((circle) => {circle.setAttribute("r", "70"); circle.setAttribute("cx", "75"); circle.setAttribute("cy", "75");});
};

    if (window.innerWidth <= 768) {
    circles.forEach((circle)=> {circle.setAttribute("r", "30"); circle.setAttribute("cx", "35"); circle.setAttribute("cy", "35");});
    circlesSecondary.forEach((circle) => {circle.setAttribute("r", "30"); circle.setAttribute("cx", "35"); circle.setAttribute("cy", "35");});
};
    if (window.innerWidth > 1050) {
    circles.forEach((circle)=> {circle.setAttribute("r", "95"); circle.setAttribute("cx", "100"); circle.setAttribute("cy", "100");});
    circlesSecondary.forEach((circle) => {circle.setAttribute("r", "95"); circle.setAttribute("cx", "100"); circle.setAttribute("cy", "100");});
};

    const now = new Date().getTime();
    const distance = countDownDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("promo-countdown__countdown-circle--days").innerHTML =  reformatNumber(days);
    document.getElementById("promo-countdown__countdown-circle--hours").innerHTML =  reformatNumber(hours);
    document.getElementById("promo-countdown__countdown-circle--minutes").innerHTML =  reformatNumber(minutes);
    document.getElementById("promo-countdown__countdown-circle--seconds").innerHTML =  reformatNumber(seconds);


    const circleLength = 2 * Math.PI * document.querySelector(".promo-countdown__circle-count-secondary").getAttribute("r");

    const secondaryCircles = document.querySelectorAll('.promo-countdown__circle-count-secondary');

    secondaryCircles.forEach((circle) => { circle.style.strokeDasharray = `${circleLength} ${circleLength}`});

    const timerLength = (time) => {
    return circleLength * time / 60;
};

    document.getElementById("promo-countdown__circle-count--days").style.strokeDasharray = `${circleLength * days / dayDistance } ${circleLength}`;

    document.getElementById("promo-countdown__circle-count--hours").style.strokeDasharray = `${timerLength(hours)} ${circleLength}`;
    document.getElementById("promo-countdown__circle-count--minutes").style.strokeDasharray = `${timerLength(minutes)} ${circleLength}`;
    document.getElementById("promo-countdown__circle-count--seconds").style.strokeDasharray = `${timerLength(seconds)} ${circleLength}`;
}, 1000);

    const reformatNumber = (number) => {
    let finalNumber;
    if (number.toString().length < 2) {
    finalNumber = "0" + number.toString();
} else {
    finalNumber = number.toString();
}

    return finalNumber;
};